export default "__VITE_ASSET__Bug_T0CO__"